import React from 'react'
import _ from 'lodash'

import ReportTable from '../report_table'
import MemberTableOrg from './report_member_table'
import * as Helper from '../../../../helpers/helper'
import { localeNumberFormatter, truncateEnd } from '../helpers'

// port of cowebapp analytics/components/email_finder/report_org_table.js
const ReportTableOrg = (props) => {

  const expandRowComp = (row) => {
    return (<MemberTableOrg
      memberData={row.stats}
      breakdown={props.userReportData.breakdown}
      id={row.user_id}
    />
    )
  }

  const expandRow = {
    className: 'expanding-row',
    parentClassName: 'parent-expand-row',
    renderer: row => expandRowComp(row)
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const emailFormatter = (cell, row) => {
    return (
      <div
        className="d-flex org-email-column"
        title={row.email}
      >
        <div className='word-break-all'>
          {truncateEnd(Helper.capitalizeFirstLetter(_.isEmpty(row.name) ? '-' : row.name), 18)}
          <small>
            <div className="d-flex">
              <span className='word-break-all'>
                {truncateEnd(row.email, 24)}
              </span>
            </div>
          </small>
        </div>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    props.tableData.forEach((data) => {
      let total = 0
      let found = 0
      let not_found = 0
      let confidence_score = 0
      let business = 0
      let role = 0
      let billable = 0
      data.stats.forEach((stat) => {
        total = total + stat.total
        found = found + stat.found
        not_found = not_found + stat.not_found
        confidence_score = confidence_score + stat.confidence_score
        business = business + stat.business
        billable = billable + stat.billable
        role = role + stat.role
      })

      tableData.push({
        email: data.email,
        stats: data.stats,
        user_id: data.user_id,
        name: data.name,
        role: role,
        total: total,
        found: found,
        not_found: not_found,
        confidence_score: confidence_score,
        business: business,
        billable: billable
      })

    })
    return tableData
  }

  const confidenceLevelFormatter = (cell, row) => {
    return row.confidence_score == 0 ? '-' : Helper.calculateConfidenceLevelTagFromScore(row.confidence_score / row.found)
  }

  const confidenceScoreFormatter = (cell, row) => {
    let score = row.confidence_score == 0 ? '' : row.confidence_score / row.found
    return score > 0 ? score.toFixed() : '-'
  }

  const data = getTableData()
  const rowClasses = 'custom-row-class'
  const formatNumber = localeNumberFormatter('-')

  const columns = [
    {
      dataField: 'email',
      text: 'Member',
      formatter: emailFormatter,
      headerStyle: { width: '20%' },
      style: { width: '20%' },
      sort: true
    },
    {
      dataField: 'found',
      text: 'Email Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Found'
    },
    {
      dataField: 'not_found',
      text: 'Email Not Found',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Not Found'
    },
    {
      dataField: 'total',
      text: 'Total Request',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'duplicate',
      text: 'Confidence Level',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceLevelFormatter,
      align: 'right'
    },
    {
      dataField: 'confidence_score',
      text: 'Confidence Score',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: confidenceScoreFormatter,
      align: 'right',
      sort: true
    },
    {
      dataField: 'business',
      text: 'Business Email',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'role',
      text: 'Role Email',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'billable',
      text: 'Billable Credits',
      headerStyle: { width: '10%' },
      style: { width: '10%' },
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  const defaultSorted = [{
    dataField: 'total',
    order: 'desc'
  }]

  return (
    <div className="report-table">
      <ReportTable
        wrapperClasses="table-report-org table-responsive"
        expandRow={expandRow}
        noDataIndication={noDataIndication}
        keyField="user_id"
        data={data}
        columns={columns}
        rowClasses={rowClasses}
        defaultSorted={defaultSorted}
      />
    </div>
  )
}

export default ReportTableOrg
